import FileSaver from "file-saver";
import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const quoteService = {
  getQuoteById,
  getQuoteItemsByIdViewMode,
  getQuoteItemsByIdEditMode,
  getQuoteByStrategyId,
  createQuote,
  updateQuote,
  updateQuoteItemDiscount,
  approveQuote,
  generatePDF,
};

const { apiUrl, apiVer } = defineConfig.QUOTE_SERVICE;

function getApiPath(){
  return (apiUrl + apiVer + "/quote");
}

function getQuoteById(id) {
  const url = `${getApiPath()}/read/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteItemsByIdViewMode(id) {
  const url = `${getApiPath()}/all/${id}/view`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteItemsByIdEditMode(id, values = null) {
  const url = `${getApiPath()}/all/${id}/edit`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getQuoteByStrategyId(strategyId) {
  const url = `${getApiPath()}/read/strategy/${strategyId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function createQuote(strategyId = "", values = null) {
  const url = `${getApiPath()}/create?strategy=${strategyId}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: values && JSON.stringify(values),
  };
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateQuote(strategyId = "", quoteId = "", values = null) {
  const url = `${getApiPath()}/update/${quoteId}?strategy=${strategyId}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: values && JSON.stringify(values),
  };
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateQuoteItemDiscount(id, discount) {
  const url = `${getApiPath()}/update/${id}/${discount}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };
  
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function approveQuote(id) {
  const url = `${getApiPath()}/update/${id}/approve`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function generatePDF(id, name) {
  const url = `${getApiPath()}/create/pdf/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
  .then(response => {
    return response.blob()
  })
  .then(function(blob) {
    FileSaver.saveAs(blob, name)
    return true;
  })
}